import {PropsWithChildren} from 'react';
import styled from 'styled-components';

interface BigButtonProps extends PropsWithChildren<{}> {
  image: string;
  size: 'small' | 'large';
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export default function BigButton({
  image,
  onClick,
  children,
  size,
  disabled,
  className = '',
}: BigButtonProps) {
  return (
    <StyledLink
      size={size}
      disabled={disabled}
      onClick={onClick}
      className={className}
    >
      <span className="image" style={{backgroundImage: `url(${image})`}} />
      <span>{children}</span>
    </StyledLink>
  );
}

const StyledLink = styled.button<{size: 'small' | 'large'}>`
  text-align: center;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({size, theme}) =>
    size === 'small' ? theme.colors.purple : 'inherit'};
  text-transform: uppercase;
  font-weight: bold;
  transition: all 200ms linear;
  font-size: clamp(13px, 2.5vw, 17px);
  background: none;
  border: none;
  cursor: pointer;

  .image {
    width: ${({size}) => (size === 'large' ? '17vw' : '10vw')};
    height: ${({size}) => (size === 'large' ? '17vw' : '10vw')};
    background-position: center center;
    background-size: ${({size}) => (size === 'large' ? 'contain' : '50%')};
    background-repeat: no-repeat;
    margin-bottom: clamp(15px, 2vh, 25px);
    transition: inherit;
    border-radius: 100%;
    ${({size, theme}) =>
      size === 'small' && `background-color: ${theme.colors.purple};`}
  }

  &.play {
    .image {
      background-position: 60% center;
    }
  }

  &:hover {
    text-decoration: underline;
  }

  & + & {
    margin-left: clamp(50px, 5vw, 100px);
  }
`;
